// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/** RentAll - Begin **/
.CoverSection-container-LETQf {
	width: 100%;
	max-width: var(--max-container-width);
	padding: 0 15px;
}
.CoverSection-seperator-TnZrm {
	background-color: var(--primary-foreground);
	width: 64px;
	display: block;
	height: 1.5px;
	margin: 0 auto;
	margin-bottom: 27px;
}
.CoverSection-boxseperator-_xqy9 {
	height: 2.5px;
	border: 1px solid var(--primary-foreground);
	background-color: transparent;
}
.CoverSection-hostingsection-TTMoH {
	margin-bottom: 160px;
}
.CoverSection-mainhedding-n2IiR h1 {
	font-size: 46px;
	line-height: 56px;
	font-weight: bold;
	margin-bottom: 30px;
	margin-top: 0;
	color: var(--primary-foreground);
}
p.CoverSection-common-d8GFw {
	font-size: 16px;
	color: var(--secondary-foreground);
	margin-bottom: 27px;
}
.CoverSection-coveredtextarea-N0UTj {
	padding-right: 96px;
}
.CoverSection-coveredSection-VUcbj a {
	font-size: 16px;
	font-weight: 400;
}
.CoverSection-coveredSectionUl-Rr_XL {
	padding: 0;
}
.CoverSection-coveredSectionUl-Rr_XL li {
	font-size: 16px;
	list-style-type: none;
	color: var(--secondary-foreground);
	margin-bottom: 23px;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	gap: 5px;
}
.CoverSection-coveredSectionUl-Rr_XL li>svg {
	position: relative;
	top: 6px;
	color: var(--secondary-bg);
}
.CoverSection-coveredSectionUl-Rr_XL li:last-child {
	margin-bottom: 0px;
}
.CoverSection-rightsidecontent-Zm7SQ {
	padding-left: 8%;
	padding-right: 0%;
}
.CoverSection-bg-4xFeC {
	background-color: var(--primary-gray-bg);
	padding: 83px 0;
}
.CoverSection-centerimgsection-mE1kx {
	padding-top: 87%;
	background-repeat: no-repeat;
	background-size: cover;
	border-radius: 6px;
}
.CoverSection-paddingLeft-cp6JS {
	padding-left: 83px;
}
@media screen and (max-width: 991px) {
	h4.CoverSection-common-d8GFw {
		font-size: 23px;
		font-weight: 600;
	}

	.CoverSection-mainhedding-n2IiR h1 {
		font-size: 36px;
		line-height: 51px;
		margin: 56px 0;
	}

	.CoverSection-paddingLeft-cp6JS {
		padding-left: 20px;
	}
}
@media screen and (max-width: 767px) {
	.CoverSection-mainhedding-n2IiR h1 {
		font-size: 24px;
		line-height: 30px;
		margin-bottom: 20px;
		text-align: left;
	}

	h4.CoverSection-common-d8GFw {
		font-size: 26px;
	}

	.CoverSection-coveredtextarea-N0UTj {
		padding-right: 15px;
		padding-left: 15px;
	}

	.CoverSection-coveredSectionUl-Rr_XL li {
		font-size: 14px;
		line-height: 2;
		margin-bottom: 10px;
	}

	p.CoverSection-common-d8GFw {
		font-size: 14px;
		line-height: 1.7;
		font-weight: 400;
	}

	.CoverSection-paddingLeft-cp6JS {
		padding-left: 25px;
		padding-top: 30px;
	}

	.CoverSection-bg-4xFeC {
		padding: 45px 0;
	}
}`, "",{"version":3,"sources":["webpack://./src/components/WhyHost/CoverSection/CoverSection.css"],"names":[],"mappings":"AAAA,sBAAsB;AACtB;CACC,WAAW;CACX,qCAAqC;CACrC,eAAe;AAChB;AAEA;CACC,2CAA2C;CAC3C,WAAW;CACX,cAAc;CACd,aAAa;CACb,cAAc;CACd,mBAAmB;AACpB;AAEA;CACC,aAAa;CACb,2CAA2C;CAC3C,6BAA6B;AAC9B;AAEA;CACC,oBAAoB;AACrB;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,iBAAiB;CACjB,mBAAmB;CACnB,aAAa;CACb,gCAAgC;AACjC;AAEA;CACC,eAAe;CACf,kCAAkC;CAClC,mBAAmB;AACpB;AAEA;CACC,mBAAmB;AACpB;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;AAEA;CACC,UAAU;AACX;AAEA;CACC,eAAe;CACf,qBAAqB;CACrB,kCAAkC;CAClC,mBAAmB;CACnB,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,QAAQ;AACT;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,0BAA0B;AAC3B;AAEA;CACC,kBAAkB;AACnB;AAEA;CACC,gBAAgB;CAChB,iBAAiB;AAClB;AAEA;CACC,wCAAwC;CACxC,eAAe;AAChB;AAEA;CACC,gBAAgB;CAChB,4BAA4B;CAC5B,sBAAsB;CACtB,kBAAkB;AACnB;AAEA;CACC,kBAAkB;AACnB;AAEA;CACC;EACC,eAAe;EACf,gBAAgB;CACjB;;CAEA;EACC,eAAe;EACf,iBAAiB;EACjB,cAAc;CACf;;CAEA;EACC,kBAAkB;CACnB;AACD;AAEA;CACC;EACC,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;CACjB;;CAEA;EACC,eAAe;CAChB;;CAEA;EACC,mBAAmB;EACnB,kBAAkB;CACnB;;CAEA;EACC,eAAe;EACf,cAAc;EACd,mBAAmB;CACpB;;CAEA;EACC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;CACjB;;CAEA;EACC,kBAAkB;EAClB,iBAAiB;CAClB;;CAEA;EACC,eAAe;CAChB;AACD","sourcesContent":["/** RentAll - Begin **/\n.container {\n\twidth: 100%;\n\tmax-width: var(--max-container-width);\n\tpadding: 0 15px;\n}\n\n.seperator {\n\tbackground-color: var(--primary-foreground);\n\twidth: 64px;\n\tdisplay: block;\n\theight: 1.5px;\n\tmargin: 0 auto;\n\tmargin-bottom: 27px;\n}\n\n.boxseperator {\n\theight: 2.5px;\n\tborder: 1px solid var(--primary-foreground);\n\tbackground-color: transparent;\n}\n\n.hostingsection {\n\tmargin-bottom: 160px;\n}\n\n.mainhedding h1 {\n\tfont-size: 46px;\n\tline-height: 56px;\n\tfont-weight: bold;\n\tmargin-bottom: 30px;\n\tmargin-top: 0;\n\tcolor: var(--primary-foreground);\n}\n\np.common {\n\tfont-size: 16px;\n\tcolor: var(--secondary-foreground);\n\tmargin-bottom: 27px;\n}\n\n.coveredtextarea {\n\tpadding-right: 96px;\n}\n\n.coveredSection a {\n\tfont-size: 16px;\n\tfont-weight: 400;\n}\n\n.coveredSectionUl {\n\tpadding: 0;\n}\n\n.coveredSectionUl li {\n\tfont-size: 16px;\n\tlist-style-type: none;\n\tcolor: var(--secondary-foreground);\n\tmargin-bottom: 23px;\n\tdisplay: flex;\n\tgap: 5px;\n}\n\n.coveredSectionUl li>svg {\n\tposition: relative;\n\ttop: 6px;\n\tcolor: var(--secondary-bg);\n}\n\n.coveredSectionUl li:last-child {\n\tmargin-bottom: 0px;\n}\n\n.rightsidecontent {\n\tpadding-left: 8%;\n\tpadding-right: 0%;\n}\n\n.bg {\n\tbackground-color: var(--primary-gray-bg);\n\tpadding: 83px 0;\n}\n\n.centerimgsection {\n\tpadding-top: 87%;\n\tbackground-repeat: no-repeat;\n\tbackground-size: cover;\n\tborder-radius: 6px;\n}\n\n.paddingLeft {\n\tpadding-left: 83px;\n}\n\n@media screen and (max-width: 991px) {\n\th4.common {\n\t\tfont-size: 23px;\n\t\tfont-weight: 600;\n\t}\n\n\t.mainhedding h1 {\n\t\tfont-size: 36px;\n\t\tline-height: 51px;\n\t\tmargin: 56px 0;\n\t}\n\n\t.paddingLeft {\n\t\tpadding-left: 20px;\n\t}\n}\n\n@media screen and (max-width: 767px) {\n\t.mainhedding h1 {\n\t\tfont-size: 24px;\n\t\tline-height: 30px;\n\t\tmargin-bottom: 20px;\n\t\ttext-align: left;\n\t}\n\n\th4.common {\n\t\tfont-size: 26px;\n\t}\n\n\t.coveredtextarea {\n\t\tpadding-right: 15px;\n\t\tpadding-left: 15px;\n\t}\n\n\t.coveredSectionUl li {\n\t\tfont-size: 14px;\n\t\tline-height: 2;\n\t\tmargin-bottom: 10px;\n\t}\n\n\tp.common {\n\t\tfont-size: 14px;\n\t\tline-height: 1.7;\n\t\tfont-weight: 400;\n\t}\n\n\t.paddingLeft {\n\t\tpadding-left: 25px;\n\t\tpadding-top: 30px;\n\t}\n\n\t.bg {\n\t\tpadding: 45px 0;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `CoverSection-container-LETQf`,
	"seperator": `CoverSection-seperator-TnZrm`,
	"boxseperator": `CoverSection-boxseperator-_xqy9`,
	"hostingsection": `CoverSection-hostingsection-TTMoH`,
	"mainhedding": `CoverSection-mainhedding-n2IiR`,
	"common": `CoverSection-common-d8GFw`,
	"coveredtextarea": `CoverSection-coveredtextarea-N0UTj`,
	"coveredSection": `CoverSection-coveredSection-VUcbj`,
	"coveredSectionUl": `CoverSection-coveredSectionUl-Rr_XL`,
	"rightsidecontent": `CoverSection-rightsidecontent-Zm7SQ`,
	"bg": `CoverSection-bg-4xFeC`,
	"centerimgsection": `CoverSection-centerimgsection-mE1kx`,
	"paddingLeft": `CoverSection-paddingLeft-cp6JS`
};
module.exports = ___CSS_LOADER_EXPORT___;
